import {
  type CmsFunnel,
  CmsFunnelBaseSchema,
  type CmsFunnelStep,
  CmsFunnelStepSchema,
} from './schema';

export function parseCmsFunnel(rawFunnel: unknown): CmsFunnel | null {
  const base = CmsFunnelBaseSchema.safeParse(rawFunnel);

  if (!base.success) {
    return null;
  }

  const steps: CmsFunnelStep[] = [];
  const seenQuestionKeys = new Set<string>();

  for (const rawStep of base.data.steps) {
    const step = CmsFunnelStepSchema.safeParse(rawStep);

    if (!step.success) {
      continue;
    }

    const { questionKey } = step.data.question;

    if (seenQuestionKeys.has(questionKey)) {
      continue;
    }

    seenQuestionKeys.add(questionKey);
    steps.push(step.data);
  }

  if (steps.length === 0) {
    return null;
  }

  return {
    ...base.data,
    steps: [...steps].sort((a, b) => a.order - b.order),
  };
}
